import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import RegisterPage from "./pages/RegisterPage";
import GestionDesTachesPage from "./pages/GestionDesTachesPage";
import BibliothequePage from "./pages/BibliothequePage";
import FacturesPage from "./pages/FacturesPage";
import ClientsPage from "./pages/ClientsPage";
import CandidatsPage from "./pages/CandidatsPage";
import CommandesPage from "./pages/commandes/CommandesPage";
import MonComptePage from "./pages/MonComptePage";
import SwitcherAgencePage from "./pages/SwitcherAgencePage";
import Annonce2 from "./pages/Annonce2";
import MentionsLegales from "./pages/MentionsLegales";
import Politique from "./pages/Politique";
import AppLayout from "./pages/AppLayout";
import Contact from "./pages/Contact";
import NouvelleFicheClient from "./pages/NouvelleFicheClient";
import NouvelleFacture from "./pages/NouvelleFacture";
import ForgotPassword from "./pages/forgotPassword/ForgotPassword";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import Task from "./pages/Task/Task";
import ContratPage from "./pages/contract/ContractPage";
import Annonces from "./pages/annonces/Annonces3";
import RelevesHeures from "./pages/rh/ReleveHeures";
import RelevesHeuresListe from "./pages/rh/RelevesHeuresListe";
import TestModalCandidat from "./components/TestModalCandidat";

function App() {
  return (
    <Routes>
      <Route path="/contact" element={<Contact />} />

      <Route path="/" element={<Home />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/login/:token" element={<LoginPage />} />
      <Route path="/RegisterPage" element={<RegisterPage />} />

      <Route path="/switcherAgence" element={<SwitcherAgencePage />} />
      <Route path="/mentions" element={<MentionsLegales />} />

      <Route path="/politique" element={<Politique />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password/:token" element={<ResetPassword />} />

      <Route path="" element={<AppLayout />}>
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/clients" element={<ClientsPage />} />
        <Route path="/bibliotheque" element={<BibliothequePage />} />
        <Route path="/facture" element={<FacturesPage />} />
        <Route path="/candidatsPage" element={<CandidatsPage />} />
        <Route path="/commandesPage" element={<CommandesPage />} />
        <Route path="/gestionDesTaches" element={<Task />} />
        <Route path="/nouvelleFacture" element={<NouvelleFacture />} />
        <Route path="/annonces" element={<Annonces />} />
        <Route path="/monCompte" element={<MonComptePage />} />
        <Route path="/contrats" element={<ContratPage />} />
        <Route path="/relevesdheures" element={<RelevesHeuresListe />} />
        <Route path="/RelevesHeures" element={<RelevesHeures />} />
        <Route path="/test-modal-candidat" element={<TestModalCandidat />} />
      </Route>
    </Routes>
  );

}

export default App;
